<div style="background: white; border: 1px solid #e5e7eb; border-radius: 16px; overflow: hidden; margin-bottom: 16px;">

  <!-- Amount header -->
  <div style="background: linear-gradient(135deg, #f0fdf4, #ecfdf5); padding: 14px 20px; border-bottom: 2px solid #bbf7d0; text-align: center;">
    <div style="display: flex; align-items: center; justify-content: center; gap: 8px;">
      <mat-icon style="font-size: 22px; width: 22px; height: 22px; color: #1C593D;">account_balance_wallet</mat-icon>
      <span style="font-size: 1.3rem; font-weight: 800; color: #1e5a3f;">
        {{ montoRetiro | currency:'CLP':'$':'1.0-0' }} CLP
      </span>
    </div>
  </div>

  <!-- Account details -->
  <div style="padding: 20px;">
    <h3 style="font-size: 0.85rem; font-weight: 700; color: #1e5a3f; margin: 0 0 16px;">Datos de la cuenta</h3>

    <div style="display: flex; align-items: center; gap: 8px; padding: 10px 0; border-bottom: 1px solid #e5e7eb;">
      <mat-icon style="font-size: 16px; width: 16px; height: 16px; flex-shrink: 0; color: #1C593D;">person</mat-icon>
      <span style="flex: 1; font-size: 0.78rem; color: #6b7280; font-weight: 500;">Titular</span>
      <span style="font-size: 0.78rem; font-weight: 700; color: #1e5a3f;">{{ account?.alias }}</span>
    </div>

    <div style="display: flex; align-items: center; gap: 8px; padding: 10px 0; border-bottom: 1px solid #e5e7eb;">
      <mat-icon style="font-size: 16px; width: 16px; height: 16px; flex-shrink: 0; color: #1C593D;">account_balance</mat-icon>
      <span style="flex: 1; font-size: 0.78rem; color: #6b7280; font-weight: 500;">Banco</span>
      <span style="font-size: 0.78rem; font-weight: 700; color: #1e5a3f;">{{ account?.banco }}</span>
    </div>

    <div style="display: flex; align-items: center; gap: 8px; padding: 10px 0; border-bottom: 1px solid #e5e7eb;">
      <mat-icon style="font-size: 16px; width: 16px; height: 16px; flex-shrink: 0; color: #1C593D;">credit_card</mat-icon>
      <span style="flex: 1; font-size: 0.78rem; color: #6b7280; font-weight: 500;">Tipo de cuenta</span>
      <span style="font-size: 0.78rem; font-weight: 700; color: #1e5a3f;">{{ account?.tipoCuenta }}</span>
    </div>

    <div style="display: flex; align-items: center; gap: 8px; padding: 10px 0;">
      <mat-icon style="font-size: 16px; width: 16px; height: 16px; flex-shrink: 0; color: #1C593D;">pin</mat-icon>
      <span style="flex: 1; font-size: 0.78rem; color: #6b7280; font-weight: 500;">Nº de cuenta</span>
      <span style="font-size: 0.78rem; font-weight: 700; color: #1e5a3f; font-family: monospace;">{{ account?.numeroCuenta }}</span>
    </div>
  </div>
</div>

<!-- Confirm button -->
<button type="button" (click)="confirmarEnvio()" [disabled]="isSubmitting"
  [style.opacity]="isSubmitting ? '0.5' : '1'"
  [style.cursor]="isSubmitting ? 'not-allowed' : 'pointer'"
  style="width: 100%; display: flex; align-items: center; justify-content: center; gap: 8px; padding: 14px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.95rem; cursor: pointer; transition: background 0.2s ease;"
  onmouseover="if(!this.disabled)this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
  <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">{{ isSubmitting ? 'hourglass_top' : 'check_circle' }}</mat-icon>
  {{ isSubmitting ? 'Procesando...' : 'Confirmar retiro' }}
</button>
